import Button from 'components/Button';
import Field from 'components/Form/Field';
import FormResult from 'components/Form/FormResult';
import SectionHeader from 'components/SectionHeader';
import Table from 'components/Table/TableStatic';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {useCancelSendViaClientinbox} from 'pages/History/SendingOrders/Details/services';
import {SendNotificationEmail} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {c, t} from 'ttag';
import {onApiError} from 'utils/request-axios/utils';

type SendViaClientinboxStatusProps = {
    flags: {
        sendToClientinbox: boolean;
    };
    isCancellable: boolean;
    isSelected: boolean;
    sentnotificationemailSet?: SendNotificationEmail[];
    statusDescription: string;
    supersendMid: string;
};

const SendViaClientinboxStatus: FC<SendViaClientinboxStatusProps> = ({
    flags,
    isCancellable,
    isSelected,
    sentnotificationemailSet,
    statusDescription,
    supersendMid,
}) => {
    const methods = useForm();
    const apiCancelSendViaClientinbox = useCancelSendViaClientinbox();

    if (!flags.sendToClientinbox || !isSelected) {
        return null;
    }

    const handleCancelSendViaClientinbox = async () => {
        await apiCancelSendViaClientinbox
            .mutateAsync({
                mid: supersendMid,
            })
            .catch(onApiError(methods));
    };

    return (
        <FormProvider {...methods}>
            <div className="flex flex-col gap-4">
                <SectionHeader title={t`"Send via Client Inbox" Status`} />
                <span className="text-base">{statusDescription}</span>
                {isCancellable && (
                    <>
                        <Field type="value">
                            <Button
                                kind="destructive"
                                onClick={handleCancelSendViaClientinbox}
                            >
                                {t`Cancel "Send via Client Inbox"`}
                            </Button>
                        </Field>
                        <FormResult />
                    </>
                )}
                {sentnotificationemailSet && (
                    <Table>
                        <Table.Header>
                            <Table.Column>{c('supersend')
                                .t`Email`}</Table.Column>
                            <Table.Column className="flex items-center gap-2">
                                {t`Status`}
                                <TooltipIcon
                                    href="https://help.makeleaps.jp/ja/articles/6046149-操作履歴-送付履歴を検索する#h_a4f7868c0a"
                                    message={t`What is “Status”?`}
                                    size="base"
                                />
                            </Table.Column>
                        </Table.Header>
                        <Table.Body>
                            {sentnotificationemailSet.map((data) => (
                                <Table.Row key={data.mid}>
                                    <Table.Cell>{data.email}</Table.Cell>
                                    <Table.Cell>
                                        {data.displayStatus}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                )}
            </div>
        </FormProvider>
    );
};
export default SendViaClientinboxStatus;
